import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/acceleratorCard/cardList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/acceleratorCard/cardList',
    meta: {
      title: '收入加速卡'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/acceleratorCard/cardDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/acceleratorCard/cardDetail',
    meta: {
      title: '收入加速卡'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/acceleratorCard/purchaseDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/acceleratorCard/purchaseDetail',
    meta: {
      title: '收入加速卡'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/acceleratorCard/buyRecordList/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/acceleratorCard/buyRecordList',
    meta: {
      title: '收入加速卡'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/acceleratorCard/surePay/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/acceleratorCard/surePay',
    meta: {
      title: '确认支付'
    }
  }
]
